import { useCallback, useRef, useReducer } from 'react';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * Shallowly merge newState into state
 */
function stateReducer(state, newState) {
  return _objectSpread({}, state, newState);
}

/**
 * Cast non-string values to a string, with the exception of functions, symbols,
 * and undefined.
 */
function toString(value) {
  switch (_typeof(value)) {
    case 'function':
    case 'symbol':
    case 'undefined':
      return '';

    default:
      return '' + value;
    // eslint-disable-line prefer-template
  }
}

var noop = function noop() {};

var defaultInputOptions = {
  onChange: noop,
  onBlur: noop,
  validate: null,
  validateOnBlur: false
};
function parseInputArgs(args) {
  var name;
  var ownValue;
  var options;

  if (typeof args[0] === 'string' || typeof args[0] === 'number') {
    var _args = _slicedToArray(args, 2);

    name = _args[0];
    ownValue = _args[1];
  } else {
    var _args2 = _slicedToArray(args, 1);

    var _args2$ = _args2[0];
    name = _args2$.name;
    ownValue = _args2$.value;
    options = _objectWithoutProperties(_args2$, ["name", "value"]);
  }

  return _objectSpread({
    name: name,
    ownValue: ownValue
  }, defaultInputOptions, options);
}

var defaultCreateId = function defaultCreateId(name, value) {
  return ['__ufs', name, value].filter(Boolean).join('__');
};

function useInputId(implementation) {
  var getId = useCallback(function (name, ownValue) {
    var createId;

    if (!implementation) {
      createId = function createId() {}; // noop

    } else if (typeof implementation === 'function') {
      createId = implementation;
    } else {
      createId = defaultCreateId;
    }

    var value = toString(ownValue);
    return value ? createId(name, value) : createId(name);
  }, [implementation]);
  var getIdProp = useCallback(function (prop, name, value) {
    var id = getId(name, value);
    return id === undefined ? {} : _defineProperty({}, prop, id);
  }, [getId]);
  return {
    getIdProp: getIdProp
  };
}

function useMarkAsDirty() {
  var dirty = useRef({});
  var isDirty = useCallback(function (name) {
    return dirty.current[name];
  }, []);
  var setDirty = useCallback(function (name, value) {
    dirty.current[name] = value;
  }, []);
  return {
    setDirty: setDirty,
    isDirty: isDirty
  };
}

var CHECKBOX = 'checkbox';
var COLOR = 'color';
var DATE = 'date';
var EMAIL = 'email';
var MONTH = 'month';
var NUMBER = 'number';
var PASSWORD = 'password';
var RADIO = 'radio';
var RANGE = 'range';
var SEARCH = 'search';
var SELECT = 'select';
var SELECT_MULTIPLE = 'selectMultiple';
var TEL = 'tel';
var TEXT = 'text';
var TEXTAREA = 'textarea';
var TIME = 'time';
var URL = 'url';
var WEEK = 'week';
var LABEL = 'label';
var TYPES = [CHECKBOX, COLOR, DATE, EMAIL, MONTH, NUMBER, PASSWORD, RADIO, RANGE, SEARCH, SELECT, SELECT_MULTIPLE, TEL, TEXT, TEXTAREA, TIME, URL, WEEK];

function noop$1() {}

var defaultFromOptions = {
  onChange: noop$1,
  onBlur: noop$1,
  onTouched: noop$1,
  withIds: false
};
function useFormState(initialState, options) {
  var formOptions = _objectSpread({}, defaultFromOptions, options);

  var _useReducer = useReducer(stateReducer, initialState || {}),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      setState = _useReducer2[1];

  var _useReducer3 = useReducer(stateReducer, {}),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      touched = _useReducer4[0],
      setTouchedState = _useReducer4[1];

  var _useReducer5 = useReducer(stateReducer, {}),
      _useReducer6 = _slicedToArray(_useReducer5, 2),
      validity = _useReducer6[0],
      setValidityState = _useReducer6[1];

  var _useInputId = useInputId(formOptions.withIds),
      getIdProp = _useInputId.getIdProp;

  var _useMarkAsDirty = useMarkAsDirty(),
      setDirty = _useMarkAsDirty.setDirty,
      isDirty = _useMarkAsDirty.isDirty;

  var createPropsGetter = function createPropsGetter(type) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _parseInputArgs = parseInputArgs(args),
          name = _parseInputArgs.name,
          ownValue = _parseInputArgs.ownValue,
          inputOptions = _objectWithoutProperties(_parseInputArgs, ["name", "ownValue"]);

      var hasOwnValue = !!toString(ownValue);
      var hasValueInState = state[name] !== undefined;
      var isCheckbox = type === CHECKBOX;
      var isRadio = type === RADIO;
      var isSelectMultiple = type === SELECT_MULTIPLE;

      function setInitialValue() {
        var value = '';

        if (isCheckbox) {
          /**
           * If a checkbox has a user-defined value, its value the form state
           * value will be an array. Otherwise it will be considered a toggle.
           */
          value = hasOwnValue ? [] : false;
        }

        if (isSelectMultiple) {
          value = [];
        }

        setState(_defineProperty({}, name, value));
      }

      function getNextCheckboxValue(e) {
        var _e$target = e.target,
            value = _e$target.value,
            checked = _e$target.checked;

        if (!hasOwnValue) {
          return checked;
        }

        var checkedValues = new Set(state[name]);

        if (checked) {
          checkedValues.add(value);
        } else {
          checkedValues.delete(value);
        }

        return Array.from(checkedValues);
      }

      function getNextSelectMultipleValue(e) {
        return Array.from(e.target.options).reduce(function (values, option) {
          return option.selected ? _toConsumableArray(values).concat([option.value]) : values;
        }, []);
      }

      function getValidationResult(e) {
        var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state;

        if (typeof inputOptions.validate === 'function') {
          return !!inputOptions.validate(e.target.value, values);
        }

        return e.target.validity.valid;
      }

      var inputProps = _objectSpread({
        name: name,

        get type() {
          if (type !== SELECT && type !== SELECT_MULTIPLE && type !== TEXTAREA) {
            return type;
          }
        },

        get multiple() {
          if (type === SELECT_MULTIPLE) {
            return true;
          }
        },

        get checked() {
          if (isRadio) {
            return state[name] === toString(ownValue);
          }

          if (isCheckbox) {
            if (!hasOwnValue) {
              return state[name] || false;
            }
            /**
             * @todo Handle the case where two checkbox inputs share the same
             * name, but one has a value, the other doesn't (throws currently).
             * <input {...input.checkbox('option1')} />
             * <input {...input.checkbox('option1', 'value_of_option1')} />
             */


            return hasValueInState ? state[name].includes(toString(ownValue)) : false;
          }
        },

        get value() {
          // auto populating initial state values on first render
          if (!hasValueInState) {
            setInitialValue();
          }
          /**
           * Since checkbox and radio inputs have their own user-defined values,
           * and since checkbox inputs can be either an array or a boolean,
           * returning the value of input from the current form state is illogical
           */


          if (isCheckbox || isRadio) {
            return toString(ownValue);
          }

          return hasValueInState ? state[name] : '';
        },

        onChange: function onChange(e) {
          setDirty(name, true);
          var value = e.target.value;

          if (isCheckbox) {
            value = getNextCheckboxValue(e);
          }

          if (isSelectMultiple) {
            value = getNextSelectMultipleValue(e);
          }

          var partialNewState = _defineProperty({}, name, value);

          var newState = _objectSpread({}, state, partialNewState);

          formOptions.onChange(e, state, newState);
          inputOptions.onChange(e);

          if (!inputOptions.validateOnBlur) {
            setValidityState(_defineProperty({}, name, getValidationResult(e, newState)));
          }

          setState(partialNewState);
        },
        onBlur: function onBlur(e) {
          if (!touched[name]) {
            setTouchedState(_defineProperty({}, name, true));
            formOptions.onTouched(e);
          }

          inputOptions.onBlur(e);
          formOptions.onBlur(e);
          /**
           * Limiting input validation on blur to:
           * A) when it's either touched for the time
           * B) when it's marked as dirty due to a value change
           */

          if (!touched[name] || isDirty(name)) {
            setValidityState(_defineProperty({}, name, getValidationResult(e)));
            setDirty(name, false);
          }
        }
      }, getIdProp('id', name, ownValue));

      return inputProps;
    };
  };

  var inputPropsCreators = TYPES.reduce(function (methods, type) {
    return _objectSpread({}, methods, _defineProperty({}, type, createPropsGetter(type)));
  }, {});
  return [{
    values: state,
    validity: validity,
    touched: touched
  }, _objectSpread({}, inputPropsCreators, _defineProperty({}, LABEL, function (name, ownValue) {
    return getIdProp('htmlFor', name, ownValue);
  }))];
}

export { useFormState };
